<template>

    <div class="row">
        <div class="col-sm-8 col-sm-offset-2">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">{{ lang.get("documents.add.header") }}</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>{{ lang.get("global.name") }}</th>
                                <th>{{ lang.get("documents.size") }}</th>
                                <th>{{ lang.get("documents.add.speed") }}</th>
                                <th>{{ lang.get("documents.add.status") }}</th>
                                <th>{{ lang.get("documents.add.action") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="!files.length">
                                <td colspan="6">
                                    <div class="text-center">
                                        <h4>{{ lang.get("documents.add.dragmsg") }}<br />{{ lang.get("documents.add.or") }}</h4>
                                        <label :for="name" class="btn btn-primary">{{ lang.get("documents.add.selectmsg") }}</label>
                                    </div>
                                </td>
                            </tr>
                            <tr v-for="(file, index) in files" :key="file.id">
                                <td>
                                    <div class="filename">
                                        {{ file.name }}
                                    </div>
                                    <div class="progress" v-if="file.active || file.progress !== '0.00'">
                                        <div :class="{'progress-bar': true, 'progress-bar-striped': true, 'progress-bar-danger': file.error, 'progress-bar-animated': file.active}" role="progressbar" :style="{width: file.progress + '%'}">{{file.progress}}%</div>
                                    </div>
                                </td>
                                <td>{{ file.size | formatSize }}</td>
                                <td>{{ file.speed | formatSize }}</td>

                                <td v-if="file.error">{{ lang.get('documents.uploaderrors.' + file.error) }}</td>
                                <td v-else-if="file.success">{{ lang.get("documents.add.success") }}</td>
                                <td v-else-if="file.active">{{ lang.get("documents.add.uploading") }}</td>
                                <td v-else></td>

                                <td>
                                    <div class="btn-group">
                                        <button :class="{'btn btn-default btn-sm dropdown-toggle':true,'disabled':file.success}" type="button" data-toggle="dropdown" aria-expanded="false">
                                            {{ lang.get('global.actions') }}
                                            <span class="caret"></span>
                                        </button>
                                        <ul class="dropdown-menu" v-if="!file.success">
                                            <li v-if="file.active"><a :class="{disabled: !file.active}" href="#" @click.prevent="file.active ? $refs.upload.update(file, {error: 'cancel'}) : false">{{ lang.get("global.cancel") }}</a></li>

                                            <li v-if="file.active"><a href="#" @click.prevent="$refs.upload.update(file, {active: false})">Stoppen</a></li>
                                            <li v-else-if="file.error && $refs.upload.features.html5"><a href="#" @click.prevent="$refs.upload.update(file, {active: true, error: '', progress: '0.00'})">Opnieuw uploaden</a></li>
                                            <li v-else><a :class="{'dropdown-item': true, disabled: file.success}" href="#" @click.prevent="file.success || file.error === 'compressing' ? false : $refs.upload.update(file, {active: true})">{{ lang.get('global.upload') }}</a></li>

                                            <li><a href="#" @click.prevent="$refs.upload.remove(file)">{{ lang.get("global.delete") }}</a></li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <vue-upload-component
                        ref="upload"
                        v-model="files"
                        :size="getMaxUploadFileSize"
                        :post-action="postUri"
                        :multiple="multiple"
                        :directory="directory"
                        :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
                        :headers="headers"
                        :data="data"
                        :drop="drop"
                        :drop-directory="dropDirectory"
                        @input-filter="inputFilter"
                        @input-file="inputFile"
                    >
                    </vue-upload-component>
                </div>
                <div class="box-body text-right" v-if="files.length > 0 && (!$refs.upload || !$refs.upload.active)">
                    <div class="btn-group">
                        <label class="btn btn-default" :for="name">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                            {{ lang.get("documents.add.addfiles") }}
                        </label>
                        <button type="button" class="btn btn-success" @click.prevent="$refs.upload.active = true">
                            <i class="fa fa-arrow-up" aria-hidden="true"></i>
                            {{ lang.get("documents.add.uploadall") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import Lang from '../../Lang';
    import VueUploadComponent from 'vue-upload-component';
    import maxUploadFilesize from "../../filters/maxUploadFilesize";

    export default {

        components: {
            VueUploadComponent,
        },

        computed: {
            getMaxUploadFileSize(){
                return maxUploadFilesize();
            },
        },

        data() {
            return {
                files:[],
                lang:Lang,
                name:'file',
                multiple:true,
                directory:false,
                drop:true,
                dropDirectory:true,
                thread:3,
                headers:{},
                data:{},
            }
        },

        methods: {

            inputFilter(newFile, oldFile, prevent){
                if (newFile && !oldFile) {
                    // Filter for some names
                    if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name) || /\.(php?|html?|jsx?|exe?)$/i.test(newFile.name) || newFile.type.substr(0,6) === "image/") {
                        return prevent()
                    }
                }
                if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                    // Create a blob field
                    newFile.blob = '';
                    let URL = window.URL || window.webkitURL;
                    if (URL && URL.createObjectURL) {
                        newFile.blob = URL.createObjectURL(newFile.file)
                    }
                }
            },

            // add, update, remove File Event
            inputFile(newFile,oldFile){
                if (newFile && oldFile) {
                    // update

                    if (newFile.active && !oldFile.active) {
                        // beforeSend
                    }

                    if (newFile.progress !== oldFile.progress) {
                        // progress
                    }

                    if (newFile.error && !oldFile.error) {
                        // error
                    }

                    if (newFile.success && !oldFile.success) {
                        // success
                    }
                }


                if (!newFile && oldFile) {
                    // remove
                    if (oldFile.success && oldFile.response.id) {
                        // TODO
                        // $.ajax({
                        //   type: 'DELETE',
                        //   url: '/upload/delete?id=' + oldFile.response.id,
                        // })
                    }
                }


                // Automatically activate upload
                if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                    if (this.uploadAuto && !this.$refs.upload.active) {
                        this.$refs.upload.active = true
                    }
                }
            },
        },

        mounted() {
            this.headers = {
                "X-CSRF-TOKEN": document.head.querySelector('meta[name="csrf-token"]').content,
                //"Content-Type": "application/x-www-form-urlencoded",
            };
        },

        name:"DocumentsAdd",

        props: {
            postUri: { required:true },
        },

    }

</script>
